define('landing',['module', 'all/slidingContentWrapper', 'boxes/events/controller-event', 'all/slidingContentNavigation', 'require', 'jquery', 'all/dialog', 'all/player/login-dialog', 'all/pretty-links', 'all/pixel-tracking', 'boxes/controllers/signup-controller', 'boxes/controllers/login-controller', 'all/hash-helper', 'all/textKey', 'boxes/events/landingEvent', 'all/jquery/jquery.parallax', 'all/jquery/jquery.cookie'], function (module, slidingContentWrapper, controllerEvent, slidingContentNavigation, require, $, dialog, loginDialog, prettyLinks, pixelTracking, signUpController, loginController, hashHelper, textKey, landingEvent) {
    'use strict';
    var landing = {};
    var configuration = module.config();

    var landingPageClass = '.cnt-overlay.start';

    function loadAboutPage(href) {
        updateBrowserUrl(href);
        document.body.className = configuration.aboutBodyClass;
        document.body.id = configuration.aboutBodyId;

        $('#bg-shadow').show();
        transition();
    }

    function loadPromotionsPage(href) {
        var $inner = $('#promotions-inner');
        $inner.show();

        loadAboutPage(href);

        $inner.find('a.logged-out').click(slidingContentWrapper.showSlidingSignup);
    }

    function updateBrowserUrl(href) {
        history.replaceState({}, '', href);
    }

    // IE is buggy. Footer remains without this.
    function fadeOutFooterBecauseIE() {
        $(landingPageClass).find('.bottom-menu').fadeOut();
    }

    function transition() {
        stopParallax();

        $(landingPageClass).addClass('inactive').delay(1000).fadeOut('fast', function() {
            $('#main-wrapper').show();
            $(document.body).css('overflow', 'auto');
        });
        fadeOutFooterBecauseIE();
    }

    function overridePromotionLinks($landingPage) {
        var $promotionLinks = $landingPage.find('a.promotions');
        $promotionLinks.click(function(event) {
            event.preventDefault();
            loadPromotionsPage($promotionLinks.attr('href'));
        });
    }

    function setupHoverBackground($landingPage) {
        $landingPage.find('.ui-button.promotions').hover(
            function () {
                $('.background ').addClass('hover');
            },
            function () {
                $('.background').removeClass('hover');
            }
        );

        $landingPage.find('.offer img').hover(
            function () {
                $('.background').addClass('hover');
            },
            function () {
                $('.background').removeClass('hover');
            }
        );
    }

    var startSignupClass = {
        createInstance: function(){
            var signup = {
                start: function(){
                    var $landingPage = $('.cnt-overlay.start, .cnt-overlay.signup');
                    var controllerClass='.signup.controller';
                    var featureClass='signup';
                    var controller = signUpController;
                    var boxControllerSelector = '.cnt-overlay.signup .signup.controller',
                        $exitButton = $landingPage.find('.middle.bar.signup');
                    controller = startSlidingController($landingPage, featureClass, controllerClass, controller, boxControllerSelector, undefined, $exitButton);
                    $landingPage.find('.close').hide();
                },
                args: undefined,
                hashTag: startSignupClass.baseHashTag
            };
            return signup;
        },
        baseHashTag: 'register'
    };

    var startLoginClass = {
        createInstance: function(){
            var login = {
                start: function(){
                    var $landingPage = $('.cnt-overlay.start, .cnt-overlay.signup');
                    var controllerClass = '.sliding-login.controller';
                    var featureClass = 'sliding-login';
                    var controller = loginController;
                    var boxControllerSelector = '.cnt-overlay.sliding-login .sliding-login.controller';
                    startSlidingController($landingPage, featureClass, controllerClass, controller, boxControllerSelector, gotoMyAccount, $landingPage.find('.close'));
                },
                args: undefined,
                hashTag: startLoginClass.baseHashTag
            };

            return login;
        },
        baseHashTag: 'login'
    };

    function showPanel(controllerStartInstanceObject){
        controllerStartInstanceObject.start();
    }


	var emptyOnPopState = function () {};

    function startSlidingController($landingPage, featureClass, controllerClass, controller, boxControllerSelector, doneCallback, $closeButton) {
        $landingPage.removeClass('start');
        $landingPage.addClass(featureClass);
        stopParallax();
        $landingPage.find('.start').removeClass('fade-in').addClass('ui-animation fade-out');
        $landingPage.find(controllerClass).removeClass('fade-out').addClass('fade-in').show();
        $landingPage.find('#start-bottom-menu').find('.language-selector .middle').removeClass('fade-in-up delay26').addClass('fade-out');
        $landingPage.find('.close').removeClass('fade-out').addClass('fade-in').show();
        $landingPage.find('#start-bottom-menu').hide();

        var $boxControllerInstance = controller.start(boxControllerSelector, doneCallback, false);
        setTimeout(function () {
            $landingPage.find('.start').hide();
            $(document.body).css('overflow-x', 'hidden');


			hashHelper.setHashStateFunction(function () {
				closeSlidingContent(event, $landingPage, controllerClass, featureClass, $boxControllerInstance);
			});

            $closeButton.off().on('click', function (event) {
                $closeButton.off().on('click', function(e) {
                    // Do nothing on next click
                    e.preventDefault();
                });
                event.preventDefault();
				hashHelper.setHashStateFunction(emptyOnPopState);
                closeSlidingContent(event, $landingPage, controllerClass, featureClass, $boxControllerInstance, slidingContentNavigation.goBackToPreviousHash);
            });

			//handler for hidden close button that shows on low height screens
			$('#close-signup-button').click(function (event) {
				event.preventDefault();
				hashHelper.setHashStateFunction(emptyOnPopState);
				closeSlidingContent(event, $landingPage, controllerClass, featureClass, $boxControllerInstance, slidingContentNavigation.goBackToPreviousHash);
			});
        }, 800);
        return $boxControllerInstance;

    }

    function closeSlidingContent(event, $landingPage, controllerClass, featureClass, $boxControllerInstance, whenDoneCallback) {
		hashHelper.setHashStateFunction(emptyOnPopState);

        event.preventDefault();
        var $controllerPage = $landingPage.find(controllerClass);
        $(document.body).css('overflow-x', 'hidden');
		$('.offer').css('z-index','101');
        $landingPage.removeClass(featureClass);
        $landingPage.addClass('start');
        $landingPage.find('.start').removeClass('fade-out').addClass('fade-in');
        $landingPage.find('.start').find('.join').removeClass('delay22');
        $controllerPage.removeClass('fade-in').addClass('ui-animation fade-out');
        $landingPage.find('.close').removeClass('fade-in').addClass('fade-out');
        $landingPage.find('.middle.bar.signup').hide();
        $controllerPage.find('.box').removeClass('slide-in-left').addClass('fade-out');

        setTimeout(function () {
            $landingPage.find('.start').show();
            $landingPage.find('#start-bottom-menu').removeClass('fade-out').addClass('fade-in').show();
            $landingPage.find('.close').hide();
            $boxControllerInstance.trigger(controllerEvent.RESET);
            if(whenDoneCallback !== undefined){
                whenDoneCallback();
            }
        }, 800);
    }

    function setupPromotionsLinks($landingPage) {
		var $promotionLinks = $landingPage.find('a.promotions.ui-button');
		var $promotionBadgeLink = $landingPage.find('.badge.promotions');
		$promotionLinks.push($promotionBadgeLink[0]);
		setSlidingControllerLinks($promotionLinks, startSignupClass);
    }

    function gotoMyAccount() {
        location.href = prettyLinks.getLink('MyPages', 'MyAccount');
    }

    function setupLogin($landingPage) {
		var $loginLinks = $landingPage.find('a.loginLink');
		setSlidingControllerLinks($loginLinks, startLoginClass);
    }

    function setSlidingControllerLinks($linksArray, startSlidingContentClass) {
        $linksArray.each(function() {
            $(this).off('click').on('click', function (event) {
                event.preventDefault();
				$('.start .offer').css('z-index','0');
                top.location.hash = '#!' + startSlidingContentClass.createInstance().hashTag;
            });
        });
    }

    function startParallax() {
        $('#scene').parallax();
    }

    function stopParallax() {
        $('#scene').parallax('disable');
    }

    function setupLanguageSelector($landingPage) {
        var hash = window.location.hash;
        while (hash.length > 0 && '#!'.indexOf(hash.substr(0, 1)) !== -1) {
            hash = hash.substr(1);
        }
        $.getJSON('/pp?flow=GetLanguageLinks', {location: window.location.pathname.split('/'), hash: hash})
            .success(function (languages) {
                if (languages.length >= 1) {
                    $landingPage.find('.language-selector').show();
                }
                var $changeLanguage = $landingPage.find('.change-language');
                $changeLanguage.applyTemplate(languages);
                $changeLanguage.find('a[data-locale]').click(function (event) {
                    event.preventDefault();
                    var $link = $(this);
                    $.ajax({
                        url: '/pp?flow=empty&locale=' + $link.data('locale'),
                        async: false
                    }).success(function() {
                        window.location.href = $link.attr('href');
                    });
                });
            });
    }

    landing.init = function init() {
        var $landingPage = $('.cnt-overlay.start, .cnt-overlay.signup');

        startParallax();
        setupPromotionsLinks($landingPage);
        setupHoverBackground($landingPage);
        setupLogin($landingPage);
        setupLanguageSelector($landingPage);
        pixelTracking.addPixelTrack('HOME');

        var allDefaultStartControllerClasses = [startSignupClass, startLoginClass];
        slidingContentNavigation.init(showPanel, allDefaultStartControllerClasses);

		if($('.cnt-overlay.signup').length > 0) {
			startSignupClass.createInstance().start();
		}
    };

    return landing;
});

